import Vue from "vue";
import Vuex from "vuex";

import { SchedulingVuexModule } from "../store/modules/SchedulingModule";
import { UserVuexModule } from "../store/modules/UserModule";
import { RoleSettingsVuexModule } from "../store/modules/RoleSettingsModule";

import { ProjectsVuexModule } from "../store/modules/ProjectsModule";
import { DevicesVuexModule } from "../store/modules/DevicesModule";
import { ClientVuexModule } from "../store/modules/ClientModule";
import { PanelConfigVuexModule } from "../store/modules/PanelConfigModule";
import { PanelVuexModule } from "../store/modules/PanelModule";
import { ProgramChainVuexModule } from "../store/modules/ProgramChainModule";
import { ClientPanelVuexModule } from "../store/modules/ClientPanelModule";
import { ToolbarContentVuexModule } from "../store/modules/ToolbarContent";
import { ProjectDetailsVuexModule } from "../store/modules/ProjectDetailsModule";
import { LocalSettingsVuexModule } from "../store/modules/LocalSettingsModule";
import { ComBoxVuexModule } from "./modules/ComBoxesModule";
import { SessionCacheVuexModule } from "./modules/SessionCacheModule";
import { LanguageVuexModule } from "./modules/LanguageVuexModule";
import { ThemeVuexModule } from "./modules/ThemeVuexModule";
import { SystemConfigurationVuexModule } from "./modules/SystemConfigurationModule";
import { UserSettingsVuexModule } from "./modules/UserSettingsModule";
import { ReportSettingsVuexModule } from "./modules/ReportSettingsModule";
import { CompanySettingsVuexModule } from "./modules/CompanySettingsModule";
import { HyDryDeviceSettingsVuexModule } from "./modules/HyDryDeviceSettingsModule";
import { ProjectManagementSettingsVuexModule } from "./modules/ProjectManagementSettingsModule";
import { AllDevicesSettingsVuexModule } from "./modules/AllDevicesSettingsModule";
import { DeviceCategoriesAndTemplatesVuexModule } from "./modules/DeviceCategoriesAndTemplatesModule";
import { HyDryMessagesSettingsVuexModule } from "./modules/HyDryMessagesSettingsModule";
import { BranchesVuexModule } from "./modules/BranchesModule";
import { SnackbarVuexModule } from "./modules/SnackbarModule";
import { AppUpdateVuexModule } from "./modules/AppUpdateModule";
import { MiraComparisonVuexModule } from "./modules/MiraComparisonModule";
import { MiraTrendGrainVuexModule } from "./modules/MiraTrendGrainModule";
import { MiraPeriodVuexModule } from "./modules/MiraPeriodModule";

Vue.use(Vuex);

export interface RootState {
  sessionCache: SessionCacheVuexModule;
  users: UserVuexModule;
  projects: ProjectsVuexModule;
  devices: DevicesVuexModule;
  client: ClientVuexModule;
  panelConfig: PanelConfigVuexModule;
  panel: PanelVuexModule;
  comBox: ComBoxVuexModule;
  clientPanel: ClientPanelVuexModule;
  toolbar: ToolbarContentVuexModule;
  programChain: ProgramChainVuexModule;
  projectDetails: ProjectDetailsVuexModule;
  localSettings: LocalSettingsVuexModule;
  roleSettings: RoleSettingsVuexModule;
  scheduling: SchedulingVuexModule;
  language: LanguageVuexModule;
  theme: ThemeVuexModule;
  systemConfiguration: SystemConfigurationVuexModule;
  userSettings: UserSettingsVuexModule;
  reportSettings: ReportSettingsVuexModule;
  companySettings: CompanySettingsVuexModule;
  hyDryDeviceSettings: HyDryDeviceSettingsVuexModule;
  projectManagementSettings: ProjectManagementSettingsVuexModule;
  allDevicesSettings: AllDevicesSettingsVuexModule;
  deviceCategoriesAndTemplates: DeviceCategoriesAndTemplatesVuexModule;
  hyDryMessagesSettings: HyDryMessagesSettingsVuexModule;
  branches: BranchesVuexModule;
  snackbar: SnackbarVuexModule;
  appUpdate: AppUpdateVuexModule;
  miraComparison: MiraComparisonVuexModule;
  miraTrendGrain: MiraTrendGrainVuexModule;
  miraPeriod: MiraPeriodVuexModule;
}

const store = new Vuex.Store<RootState>({});

export default store;
